export * from './ngx-loading-animate.component';
export * from './ngx-loading-animate.service';
